'use strict';

const headings = document.querySelectorAll('.js-accordion-subhead');

/**
 * Based on the fantastic work of Heydon Pickering
 *
 * @see https://inclusive-components.design/tabbed-interfaces/
 *
 */
const init = function () {

	if (headings) {
		setupAccordions();
	}

};


/**
 *
 *
 */
const setupAccordions = function () {

	Array.prototype.forEach.call(headings, heading => {

		let btn = heading.querySelector('button');
		let parent = heading.parentElement;
		let target = heading.nextElementSibling;

		btn.onclick = () => {
			let expanded = btn.getAttribute('aria-expanded') === 'true' || false;
			btn.setAttribute('aria-expanded', !expanded);
			target.hidden = expanded;
			parent.classList.toggle('is-active');
		};

	});

};

const api = {
	init: init
};

export default api;